'use client';

import Link from "next/link";
import { Button } from "@repo/ui";
import { ArrowRight, Check } from "lucide-react";
import { BackgroundLayers } from "@/components/ui/BackgroundLayers";
import { useTranslation } from '@/lib/i18n/use-translation';

const NewHero = () => {
  const { t } = useTranslation();

  const trustIndicators = [
    t('marketingLanding.hero.trustIndicators.noCreditCard'),
    t('marketingLanding.hero.trustIndicators.freeTrial'),
    t('marketingLanding.hero.trustIndicators.cancelAnytime'),
  ];

  return (
    <BackgroundLayers variant="intense" className="relative overflow-hidden">
      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
        <div className="mx-auto max-w-4xl text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-yellow-100 dark:bg-brand-yellow-900/30 text-brand-yellow-700 dark:text-brand-yellow-300 rounded-full text-sm font-medium mb-8 border border-brand-yellow-200/50">
            <Check className="h-4 w-4" />
            {t('marketingLanding.hero.badge')}
          </div>

          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight text-foreground mb-6">
            {t('marketingLanding.hero.titleLine1')}
            <span className="block bg-gradient-to-r from-brand-yellow-600 via-brand-yellow-500 to-brand-blue-600 bg-clip-text text-transparent">
              {t('marketingLanding.hero.titleLine2')}
            </span>
          </h1>
          
          <p className="text-xl sm:text-2xl text-muted-foreground mb-8 max-w-3xl mx-auto leading-relaxed">
            {t('marketingLanding.hero.description')}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 py-6 text-lg font-semibold shadow-layered">
              <Link href="/sign-up-landing">
                {t('marketingLanding.hero.startFree')}
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
            <Button variant="outline" size="lg" className="px-8 py-6 text-lg border-2 border-border hover:border-primary/50">
              <Link href="#demo">{t('marketingLanding.hero.watchDemo')}</Link>
            </Button>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-8 text-sm text-muted-foreground">
            {trustIndicators.map((indicator) => (
              <div key={indicator} className="flex items-center gap-2">
                <Check className="h-4 w-4 text-brand-yellow-600 dark:text-brand-yellow-400" />
                {indicator}
              </div>
            ))}
          </div>
        </div>
      </div>
    </BackgroundLayers>
  );
};

export default NewHero;
